import { render } from "./ThanksMessagePointSummary.vue?vue&type=template&id=535a1d1c&scoped=true&ts=true"
import script from "./ThanksMessagePointSummary.vue?vue&type=script&lang=ts"
export * from "./ThanksMessagePointSummary.vue?vue&type=script&lang=ts"

import "./ThanksMessagePointSummary.vue?vue&type=style&index=0&id=535a1d1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a1d1c"]])

export default __exports__